(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aiimagemodel2"] && !Shopify.designMode) return;
  try {
    
  // State Management
  let currentMode = null; // "prompt" or "upload"
  let creditsRemaining = 3;
  let isGenerating = false;
  // Track which image is currently chosen (Default to null until generated)
  let selectedImageSrc = null; 

  // DOM Elements
  const entrySelection = document.getElementById('entrySelection');
  const generatorInterface = document.getElementById('generatorInterface');
  const promptModeCard = document.getElementById('promptModeCard');
  const uploadModeCard = document.getElementById('uploadModeCard');
  const backBtn = document.getElementById('backBtn');
  const uploadZoneContainer = document.getElementById('uploadZoneContainer');
  const uploadZone = document.getElementById('uploadZone');
  const fileInput = document.getElementById('fileInput');
  const thumbnailPreview = document.getElementById('thumbnailPreview');
  const previewImage = document.getElementById('previewImage');
  const editDescription = document.getElementById('editDescription');
  
  // NEW ELEMENTS FOR SPLIT VIEW
  const transformationSection = document.getElementById('transformationSection');
  const resultCard1 = document.getElementById('resultCard1');
  const resultCard2 = document.getElementById('resultCard2');
  const resultImg1 = document.getElementById('resultImg1');
  const resultImg2 = document.getElementById('resultImg2');

  const productMockupSection = document.getElementById('productMockupSection');
  const creditsDisplay = document.getElementById('creditsDisplay');
  const generateBtn = document.getElementById('generateBtn');
  const heroHeading = document.getElementById('heroHeading');
  const heroSubheading = document.getElementById('heroSubheading');

  // Entry Selection Handlers
  promptModeCard.addEventListener('click', () => {
    currentMode = 'prompt';
    showGenerator();
    uploadZoneContainer.style.display = 'none';
    editDescription.placeholder = 'e.g. a retro cartoon dog astronaut, bold colors, clean background';
    updateHeroCopy();
    updateGenerateButtonText();
  });

  uploadModeCard.addEventListener('click', () => {
    currentMode = 'upload';
    showGenerator();
    uploadZoneContainer.style.display = 'block';
    editDescription.placeholder = 'Describe how you want to edit this image (style, background, mood…)';
    editDescription.required = false;
    updateHeroCopy();
    updateGenerateButtonText();
  });

  backBtn.addEventListener('click', () => {
    resetGenerator();
  });

  function showGenerator() {
    entrySelection.style.display = 'none';
    generatorInterface.style.display = 'block';
  }

  function resetGenerator() {
    currentMode = null;
    entrySelection.style.display = 'block';
    generatorInterface.style.display = 'none';
    transformationSection.style.display = 'none';
    thumbnailPreview.style.display = 'none';
    fileInput.value = '';
    editDescription.value = '';
    productMockupSection.style.display = 'none';
    
    // Reset hero to default
    heroHeading.textContent = 'Upload Your Photo & Transform It with AI Magic';
    heroSubheading.textContent = 'Turn family pics, pet photos, or any image you own into stunning print-ready designs. See results instantly and shop your creations.';
  }

  // Dynamic Hero Copy Based on Mode
  function updateHeroCopy() {
    if (currentMode === 'prompt') {
      heroHeading.textContent = 'Create Stunning Designs with AI';
      heroSubheading.textContent = 'Describe your idea and turn it into a print-ready design.';
    } else if (currentMode === 'upload') {
      heroHeading.textContent = 'Transform Your Photo with AI';
      heroSubheading.textContent = 'Edit and enhance images you already own.';
    }
  }

  // Context-Aware Generate Button Text
  function updateGenerateButtonText() {
    if (currentMode === 'prompt') {
      generateBtn.textContent = 'Generate Design';
    } else if (currentMode === 'upload') {
      generateBtn.textContent = 'Generate Edit';
    }
  }

  // Loading State Management
  function setGeneratingState(generating) {
    isGenerating = generating;
    generateBtn.disabled = generating;
    generateBtn.textContent = generating ? 'Generating…' : 
      (currentMode === 'prompt' ? 'Generate Design' : 'Generate Edit');
  }

  // Upload Zone Functionality
  uploadZone.addEventListener('click', () => {
    if (currentMode === 'upload') {
      fileInput.click();
    }
  });

  uploadZone.addEventListener('dragover', (e) => {
    e.preventDefault();
    uploadZone.style.borderColor = 'var(--primary)';
  });

  uploadZone.addEventListener('dragleave', () => {
    uploadZone.style.borderColor = '#E5BFA0';
  });

  uploadZone.addEventListener('drop', (e) => {
    e.preventDefault();
    uploadZone.style.borderColor = '#E5BFA0';
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      handleFileUpload(files[0]);
    }
  });

  fileInput.addEventListener('change', (e) => {
    if (e.target.files.length > 0) {
      handleFileUpload(e.target.files[0]);
    }
  });

  function handleFileUpload(file) {
    if (file && file.type.match('image.*')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        previewImage.src = e.target.result;
        thumbnailPreview.style.display = 'block';
      };
      reader.readAsDataURL(file);
    }
  }

  // Remove image
  document.querySelector('.printee-remove-btn').addEventListener('click', (e) => {
    e.stopPropagation();
    thumbnailPreview.style.display = 'none';
    fileInput.value = '';
  });

  // Form Submission with Prompt Construction
  document.getElementById('printeeForm').addEventListener('submit', (e) => {
    e.preventDefault();
    
    // Validation checks
    if (creditsRemaining <= 0) {
      alert('No credits remaining. Please get more credits to continue.');
      return;
    }

    // Get form values
    const userPrompt = editDescription.value.trim();
    const model = document.getElementById('modelSelect').value;
    const style = document.getElementById('styleSelect').value;
    const creativity = document.getElementById('creativitySlider').value;

    // Validate prompt for prompt mode
    if (currentMode === 'prompt' && !userPrompt) {
      alert('Please enter a description for your design.');
      return;
    }

    // Validate upload for upload mode
    if (currentMode === 'upload' && !previewImage.src) {
      alert('Please upload an image first.');
      return;
    }

    // Construct final prompt with style prepended
    const finalPrompt = style ? `${style} style, high contrast: ${userPrompt}` : userPrompt;

    // Prepare data for API
    const generationData = {
      mode: currentMode,
      prompt: finalPrompt,
      rawPrompt: userPrompt,
      model: model,
      style: style,
      creativity: creativity,
      image: currentMode === 'upload' ? previewImage.src : null
    };

    console.log('Generating with:', generationData);

    // Set loading state
    setGeneratingState(true);

    // Call API
    callPromptGeneration(generationData);
  });

  // --- ROBUST PROMPT GENERATION FUNCTION ---
  async function callPromptGeneration(data) {
    try {
      if (data.mode !== 'prompt') throw new Error('Wrong mode for prompt generation');

      console.log("Sending request to n8n...");

      const response = await fetch('https://printeeai.app.n8n.cloud/webhook-test/model2', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
           prompt: data.prompt,
           model: data.model,
           creativity: data.creativity
        })
      });

      if (!response.ok) throw new Error(`Network error: ${response.status}`);

      // 1. Get raw text first to debug safely
      const rawText = await response.text();
      console.log("DEBUG - Raw n8n String:", rawText);

      // 2. Parse JSON
      let rootData;
      try {
        rootData = JSON.parse(rawText);
      } catch (e) {
        throw new Error("Response was not valid JSON");
      }
      
      console.log("DEBUG - Parsed Object:", rootData);

      // 3. Robust Data Extraction
      // Handle Case A: Array wrapper [ { images: ... } ]
      let content = Array.isArray(rootData) ? rootData[0] : rootData;
      
      // Handle Case B: n8n sometimes wraps in a 'body' key
      if (content.body) content = content.body;

      // 4. Find the Images Array
      // We look for 'images', 'output', or 'data'
      const imagesArray = content.images || content.output || content.data;

      if (!imagesArray || !Array.isArray(imagesArray) || imagesArray.length === 0) {
        console.error("Structure Error. Looked inside:", content);
        throw new Error('Could not find "images" array in response.');
      }

      // 5. Safe URL Extraction Helper
      const getUrl = (item) => {
         if (!item) return null;
         // Check "Location" (Capital L from your screenshot), "location", "url", or "src"
         return item.Location || item.location || item.url || item.src;
      };

      const img1Url = getUrl(imagesArray[0]);
      // If there is no second image, just reuse the first one
      const img2Url = getUrl(imagesArray[1]) || img1Url;

      if (!img1Url) {
         console.error("URL Error. First item was:", imagesArray[0]);
         throw new Error("Found images array, but could not find a URL property (Location/location/url).");
      }

      // --- SUCCESS: UPDATE FRONTEND ---
      
      // Set Image Sources
      resultImg1.src = img1Url;
      resultImg2.src = img2Url;
      
      // Default select the first card
      selectCard(1);

      // Show Section
      transformationSection.style.display = 'block';
      transformationSection.scrollIntoView({ behavior: 'smooth' });

      // Decrement credits
      creditsRemaining--;
      updateCreditsDisplay();

    } catch (error) {
      console.error("Generation Failed:", error);
      alert('Image generation failed. Check console for details.');
    } finally {
      setGeneratingState(false);
    }
  }

  function updateCreditsDisplay() {
    creditsDisplay.textContent = `${creditsRemaining} edit${creditsRemaining !== 1 ? 's' : ''} remaining`;
  }

  // --- NEW SELECTION LOGIC (Split View) ---
  function selectCard(cardNum) {
    // Styling: Highlight selected, dim unselected
    if (cardNum === 1) {
        resultCard1.classList.add('selected');
        resultCard1.style.borderColor = 'var(--primary)';
        resultCard1.style.opacity = '1';
        
        resultCard2.classList.remove('selected');
        resultCard2.style.borderColor = 'transparent';
        resultCard2.style.opacity = '0.6';
        
        selectedImageSrc = resultImg1.src;
    } else {
        resultCard2.classList.add('selected');
        resultCard2.style.borderColor = 'var(--primary)';
        resultCard2.style.opacity = '1';
        
        resultCard1.classList.remove('selected');
        resultCard1.style.borderColor = 'transparent';
        resultCard1.style.opacity = '0.6';
        
        selectedImageSrc = resultImg2.src;
    }
  }

  // Add Click Listeners
  if(resultCard1) resultCard1.addEventListener('click', () => selectCard(1));
  if(resultCard2) resultCard2.addEventListener('click', () => selectCard(2));

  // Regenerate Button
  document.getElementById('regenerateBtn').addEventListener('click', () => {
    if (creditsRemaining <= 0) {
      alert('No credits remaining. Please get more credits to continue.');
      return;
    }
    document.getElementById('printeeForm').dispatchEvent(new Event('submit'));
  });

  // Put on Product Button
  document.getElementById('putOnProductBtn').addEventListener('click', () => {
    productMockupSection.style.display = 'block';
    productMockupSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    
    // Generate initial mockup
    updateProductMockup();
  });

  // Product Selection Change
  document.getElementById('productSelect').addEventListener('change', () => {
    updateProductMockup();
  });

  function updateProductMockup() {
    const product = document.getElementById('productSelect').value;
    const mockupImage = document.getElementById('productMockup');
    
    // Ensure we are using the currently selected image
    console.log('Generating mockup for:', product, 'using image:', selectedImageSrc);
    
    // For demo, showing placeholder
    mockupImage.src = `https://via.placeholder.com/600x600?text=${product}+with+Selected+AI+Design`;
  }

  // Buy Now Button
  document.getElementById('buyNowBtn').addEventListener('click', () => {
    const product = document.getElementById('productSelect').value;
    console.log('Proceeding to checkout with:', product);
    
    // HERE: Redirect to Shopify product page or add to cart
    alert(`Adding ${product} to cart and proceeding to checkout!`);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
